module.exports = __webpack_public_path__ + "static/bg-amdocs-6ed5bef8c78d4a1c805df4699a0aaa5a.webp";